import React, { useState, useEffect, useCallback } from 'react';
import FloatingHearts from './FloatingHearts';
import SuccessModal from './SuccessModal';
import ErrorMessage from './ErrorMessage';

const ValentinesPage = () => {
  const [noButtonPosition, setNoButtonPosition] = useState({ x: 0, y: 0 });
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showHearts, setShowHearts] = useState(false);
  const [isMoving, setIsMoving] = useState(false);

  const handleMouseMove = useCallback((e) => {
    const button = document.getElementById('no-button');
    if (!button || isMoving) return;

    const mouseX = e.clientX;
    const mouseY = e.clientY;
    const buttonRect = button.getBoundingClientRect();
    const buttonWidth = buttonRect.width;
    const buttonHeight = buttonRect.height;

    const distance = Math.sqrt(
      Math.pow(mouseX - (buttonRect.x + buttonWidth / 2), 2) +
      Math.pow(mouseY - (buttonRect.y + buttonHeight / 2), 2)
    );

    if (distance < 120) {
      setIsMoving(true);
      
      const angleToMouse = Math.atan2(
        mouseY - (buttonRect.y + buttonHeight / 2),
        mouseX - (buttonRect.x + buttonWidth / 2)
      );

      const moveAngle = angleToMouse + Math.PI + (Math.random() - 0.5);
      const moveDistance = Math.max(150, distance * 2);

      let newX = Math.cos(moveAngle) * moveDistance;
      let newY = Math.sin(moveAngle) * moveDistance;

      newX += (Math.random() - 0.5) * 100;
      newY += (Math.random() - 0.5) * 100;

      const startX = window.innerWidth / 2 + 128;
      const startY = window.innerHeight / 2;

      newX = Math.max(-startX + 20, Math.min(newX, window.innerWidth - startX - buttonWidth - 20));
      newY = Math.max(-startY + 20, Math.min(newY, window.innerHeight - startY - buttonHeight - 20));

      setNoButtonPosition({ x: newX, y: newY });

      setTimeout(() => {
        setIsMoving(false);
      }, 300);
    }
  }, [isMoving]); // Include isMoving in dependencies

  const handleYesClick = () => {
    setShowSuccessDialog(true);
    setShowHearts(true);
  };

  const handleNoClick = () => {
    setShowErrorMessage(true);
    setTimeout(() => setShowErrorMessage(false), 3000);
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handleMouseMove]); // Now we can safely include handleMouseMove


  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-red-50 flex flex-col items-center justify-center p-4">
      {showHearts && <FloatingHearts />}

      <div className="text-center mb-12 transform hover:scale-105 transition-transform duration-300">
        <h1 className="text-5xl font-bold text-pink-600 mb-6 drop-shadow-lg">
          Vil du være min Valentine? 💝
        </h1>
        <p className="text-xl text-gray-700 italic">
          Jeg må spørre deg om noe viktig...
        </p>
      </div>

      <div className="flex gap-32 items-center justify-center">
        <button
          onClick={handleYesClick}
          className="px-12 py-6 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xl font-bold rounded-2xl hover:from-pink-600 hover:to-rose-600 hover:scale-110 transition-all duration-300 shadow-lg hover:shadow-xl z-10"
        >
          Ja 😊
        </button>

        <button
          id="no-button"
          onClick={handleNoClick}
          className="px-12 py-6 bg-gray-500 text-white text-xl font-bold rounded-2xl hover:bg-gray-600 transition-all duration-300 shadow-lg"
          style={{
            transform: `translate(${noButtonPosition.x}px, ${noButtonPosition.y}px)`,
            transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }}
        >
          Nei 😢
        </button>
      </div>

      {showSuccessDialog && <SuccessModal />}
      {showErrorMessage && <ErrorMessage />}
    </div>
  );
};

export default ValentinesPage;